// Hero Mo slider
const heroModule = document.querySelectorAll('[data-slider="hero-module-slider"]');

const heroModuleOptions = {
  watchOverflow: true,
  loop: true,
  spaceBetween: 24,
  slidesPerView: 1,
  speed: 1200,
  autoplay: {
    delay: 3000,
  },
  allowTouchMove: false,
};

heroModule.forEach((el) => {
  new Swiper(el, heroModuleOptions);
});
